import { uuid } from '@/utils';
import orderBy from 'lodash/orderBy';

const state = {
  historyList: [],
};

const getters = {
  historyList: state =>
    orderBy(state.historyList, 'timestamp', 'desc').slice(0, 15),
};

const mutations = {
  SET_HISTORY_LIST(state, historyList) {
    state.historyList = historyList;
  },

  PUSH(state, title) {
    state.historyList.push({
      id: uuid(),
      title,
      timestamp: +new Date(),
    });
  },

  DELETE(state, removeHistory) {
    state.historyList = state.historyList.filter(history => {
      return history.id !== removeHistory.id;
    });
  },

  CLEAR(state) {
    state.historyList = [];
  },
};

const actions = {
  add({ commit, state }, title) {
    if (!title) return;

    const removeHistory = state.historyList.find(_ => _.title === title);

    if (removeHistory) {
      commit('DELETE', removeHistory);
    }

    commit('PUSH', title);
  },

  clear({ commit }) {
    commit('CLEAR');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
